import React, { FC, ReactNode } from 'react';
import _                        from 'underscore';
import { trimString }           from '../../../util';
import { EMPTY_VALUE_DISPLAY }  from '../../../constants/FormatStringEnums';

interface Props {
	evaluate?: string,
	passValue?: ReactNode,
	emptyValue?: any,
}

const defaultProps: Props = {
	evaluate:   null,
	passValue:  null,
	emptyValue: EMPTY_VALUE_DISPLAY
}

const StringOrEmpty: FC<Props> = ( props ) => {
	
	let value = trimString( props.evaluate );
	
	try{
		return ( _.isEmpty( value ) )
		       ? <span className={ 'text--muted' }>{ props.emptyValue }</span>
		       : <>{ props.passValue ?? props.evaluate }</>;
		
	} catch( e ) {
		
		// bad string
	}
	
	return props.emptyValue;
}

StringOrEmpty.defaultProps = defaultProps;

export { StringOrEmpty };
